<template>
  <div class="bg-blue-dark tooltip--popup absolute mb-1/2">
    <p class="text-white p-1/4 m-0">{{ content }}</p>
  </div>
</template>
<style lang="scss" scoped>
.tooltip--popup {
  border-radius: 8px;
  width: 210px;
  left: calc(50% - 30px);
  bottom: 100%;
  transform: translateX(-50%);
  padding: 6px 10px;

  &::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 6px 6px 0 6px;
    border-color: #00263e transparent transparent transparent;
  }
}
</style>
<script>
export default {
  props: {
    content: {
      required: true,
      type: String,
    },
  },
};
</script>
